const collectionCache = new Map();
const storefrontApiVersion = '2026-04';
const mainWidths = [180, 360, 540, 720];
const hoverWidths = [180, 360, 540, 720];
const arrowLeftSvg = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-arrow-right" viewBox="0 0 14 26" width="8" height="15"><path d="M12 24.656c.078 0 .156-.016.234-.047s.133-.066.187-.129c.117-.117.176-.258.176-.422s-.059-.305-.176-.422l-10.371-10.371L12.422 2.883c.117-.117.176-.258.176-.422s-.059-.305-.176-.422-.258-.176-.422-.176-.305.059-.422.176l-10.805 10.793a.59.59 0 0 0-.176.434c0 .172.059.305.176.422L11.578 24.48a.42.42 0 0 0 .199.129.54.54 0 0 0 .223.047zm0 0" fill="#0f0f0f"></path></svg>`;
const arrowRightSvg = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-arrow-left" viewBox="0 0 14 26" width="8" height="15"><path d="M2 24.656c-.078 0-.156-.016-.234-.047s-.133-.066-.187-.129c-.117-.117-.176-.258-.176-.422s.059-.305.176-.422l10.371-10.371L1.578 2.883c-.117-.117-.176-.258-.176-.422s.059-.305.176-.422.258-.176.422-.176.305.059.422.176l10.805 10.793a.59.59 0 0 1 .176.434c0 .172-.059.305-.176.422L2.422 24.48a.42.42 0 0 1-.199.129.54.54 0 0 1-.223.047zm0 0" fill="#0f0f0f"></path></svg>`;
const dropFilledSvg = `<svg width="9" height="11" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.45.222c-.203-.296-.7-.296-.9 0l-.001.002c-1.538 3.55-2.994 5.82-4.122 7.578-1.342 2.094-2.22 3.463-2.22 5.405C1.207 16.952 4.256 20 8 20a6.802 6.802 0 0 0 6.792-6.793c0-1.944-.878-3.314-2.22-5.408C11.443 6.04 9.987 3.772 8.45.222Z" fill="#000"/></svg>`;
const dropEmptySvg = `<svg width="9" height="11" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.45.222c-.203-.296-.7-.296-.9 0C4.18 8 1.207 9.63 1.207 13.207 1.207 16.952 4.256 20 8 20a6.802 6.802 0 0 0 6.792-6.793C14.792 9.63 11.822 8 8.45.222ZM8 18.913a5.711 5.711 0 0 1-5.706-5.706C2.294 10.725 7 5 8 1.508c1 3.492 5.706 9.215 5.706 11.7A5.712 5.712 0 0 1 8 18.912Z" fill="#000"/></svg>`;

const colorMap = {
  'Apricot': '#F4B31A',
  'Apricot/Neon Pink': '#F4B31A',
  'Beige': { hex: '#EAD8AB', light: true },
  'Black': '#000000',
  'Black/Candy Pink': '#000000',
  'Black Dots': '#000000',
  'Black/Fiery Red': '#000000',
  'Black Leopard': '#000000',
  'Black Rib': '#000000',
  'Black/Crystal': '#000000',
  'Black/Silver': '#000000',
  'Black/White': '#000000',
  'Blush': '#A1655B',
  'Bright Blue': '#2D4494',
  'Bubblegum Pink': '#FF6692',
  'Burgundy': '#661C1A',
  'Burgundy/Neon Pink': '#661C1A',
  'Candy Pink': '#F9A5D6',
  'Candy Pink/Electric Blue': '#F9A5D6',
  'Cherry': '#783447',
  'Cherry/Coral': '#783447',
  'Cobalt Blue': '#203C7F',
  'Coffee': '#4B342F',
  'Coral': '#F0635B',
  'Coral/Cherry': '#F0635B',
  'Coral/Sky': '#F97F7F',
  'Coral/Warm Nude': '#F0635B',
  'Cream': { hex: '#FEFAEB', light: true },
  'Cream/Baby Blue': { hex: '#FEFAEB', light: true },
  'Cream/Black': { hex: '#FEFAEB', light: true },
  'Cream/Red': { hex: '#FEFAEB', light: true },
  'Deep Teal Orchid': { hex: '#BCE3DF', light: true },
  'Dusty Rose': '#BA7D7F',
  'Electric Blue': '#3950A0',
  'Electric Blue/Candy Pink': '#3950A0',
  'Electric Lilac': '#CB6BE5',
  'Electric Lilac/Apricot': '#CB6BE5',
  'Electric Lilac/Neon Pink': '#CB6BE5',
  'Faded Blue': '#4E6582',
  'Faded Red': '#C27361',
  'Fiery Red': '#ED2E2D',
  'Green': { hex: '#7AED92', light: true },
  'Green Ivy': '#288E3E',
  'Grey': '#575358',
  'Hot Pink': '#D6316E',
  'Kelly Green': '#2CAE66',
  'Lavender': '#C493B5',
  'Leopard': { hex: '#EBCBA7', light: true },
  'Leopard/Candy Pink': { hex: '#EBCBA7', light: true },
  'Light Blue': '#ABCDD9',
  'Light Blue/Fiery Red': '#ABCDD9',
  'Light Yellow': { hex: '#FDFCC0', light: true },
  'Lilac': '#806ED3',
  'Mango': '#E9A900',
  'Matcha': '#A4BC3A',
  'Mauve': '#A18F85',
  'Mint Green': { hex: '#70FC86', light: true },
  'Mocha/Candy Pink': '#8C543A',
  'Multicolor': { hex: '#FFFFFF', light: true },
  'Mustard/Electric Lilac': '#D39237',
  'Navy Blue': '#27293D',
  'Navy Blue/Neon Pink': '#27293D',
  'Neon Pink': '#FF009E',
  'Neon Yellow': { hex: '#EDFF00', light: true },
  'Nude': '#EABEBE',
  'Off White': { hex: '#F1F0F0', light: true },
  'Olive': '#63563B',
  'Olive Abstract Floral': '#63563B',
  'Olive/Lavender': '#63563B',
  'Pale Pink/Burgundy': '#ECB2B3',
  'Pale Pink/Deep Red': '#ECB2B3',
  'Papaya': '#EC1F23',
  'Pastel Lilac': '#BCAFCF',
  'Peach': { hex: '#FFBE98', light: true },
  'Peach/Turquoise': { hex: '#FFBE98', light: true },
  'Pine Green': '#264445',
  'Pine Green/Candy Pink': '#264445',
  'Pink': '#E5659A',
  'Pistache': { hex: '#CADEA6', light: true },
  'Powder Pink': '#EDB2B3',
  'Powder Pink/Fiery Red': '#EDB2B3',
  'Powder Pink/Light Yellow': '#EDB2B3',
  'Rust': '#6F372C',
  'Sky Blue': '#2B60B3',
  'Terracotta': '#6F372C',
  'Turquoise': '#93D1BB',
  'Turquoise Blue': '#0093F6',
  'Turquoise/Coral': '#93D1BB',
  'Turquoise/Peach': '#93D1BB',
  'Warm Nude': '#D6A881',
  'Warm Nude/Candy Pink': '#D6A881',
  'Warm Nude/Coral/Turquoise': '#D6A881',
  'Warm Nude/Light Pink/Light Yellow': '#D6A881',
  'Warm Nude/Lilac': '#D6A881',
  'White': { hex: '#FFFFFF', light: true },
  'White/Black': { hex: '#FFFFFF', light: true },
  'Zesty Lime': { hex: '#BBDF32', light: true },
};

const getColorHex = (colorName, swatchColor) => {
  if (swatchColor) return swatchColor;

  const mapped = colorMap[colorName];
  if (!mapped) return '#FFFFFF';

  return typeof mapped === 'string' ? mapped : mapped.hex;
};

const isLightColor = (colorName, hex) => {
  const mapped = colorMap[colorName];

  if (mapped && typeof mapped === 'object' && mapped.light) return true;

  return hex === '#FFFFFF';
};

const getColorOption = (product) => {
  const option = product.options?.find(
    (opt) => opt.name.toLowerCase() === 'color' || opt.name.toLowerCase() === 'colour',
  );

  if (!option) return { name: '', swatchColor: null };

  return {
    name: option.optionValues?.[0]?.name ?? option.values?.[0] ?? '',
    swatchColor: option.optionValues?.[0]?.swatch?.color ?? null,
  };
};

const getNumericId = (gid) => {
  if (!gid) return '';

  const parts = String(gid).split('/');
  return parts[parts.length - 1];
};

const normalizeContextCode = (value, fallback = null) => {
  if (!value || typeof value !== 'string') return fallback;

  const normalized = value
    .trim()
    .replace('_', '-')
    .split('-')[0]
    ?.toUpperCase();

  if (!normalized || normalized.length < 2) return fallback;

  return normalized;
};

const buildSrcset = (url, widths) => {
  if (!url) return '';

  const separator = url.includes('?') ? '&' : '?';
  return widths.map((width) => `${url}${separator}width=${width} ${width}w`).join(', ');
};

const formatPrice = (amount) => {
  if (!amount) return '';

  const normalizedAmount = String(amount).replace(/,/g, '').trim();
  const parsedAmount = Number.parseFloat(normalizedAmount);
  if (Number.isNaN(parsedAmount)) return '';

  const cents = Math.round(parsedAmount * 100);
  const formatted = theme.Currency.formatMoney(cents, theme.settings.moneyFormat);

  return formatted.replace(/([.,])00(?=\s*[^\d\s]+$|\s*$)/, '');
};

const getDiscountPercent = (price, compareAtPrice) => {
  if (!price || !compareAtPrice) return 0;

  const parsedPrice = parseFloat(price);
  const parsedCompareAtPrice = parseFloat(compareAtPrice);

  if (parsedCompareAtPrice <= parsedPrice) return 0;

  const rawDiscountPercent = ((parsedCompareAtPrice - parsedPrice) / parsedCompareAtPrice) * 100;
  return Math.floor(rawDiscountPercent / 5 + 0.5) * 5;
};

const getCustomLabelFromTags = (tags) => {
  if (!tags?.length) return null;

  for (const tag of tags) {
    if (tag.startsWith('_label_')) return tag.replace('_label_', '');
  }

  return null;
};

const buildTopBadgesHtml = (product) => {
  let html = '';
  const tags = product.tags ?? [];
  const minPrice = product.priceRange?.minVariantPrice?.amount;
  const comparePrice = product.compareAtPriceRange?.minVariantPrice?.amount;
  const hideSaleTag = theme.settings.hideSaleBadgeTag;
  const hasHideSaleTag = hideSaleTag && tags.includes(hideSaleTag);

  const customLabel = product.themeLabel?.value ?? getCustomLabelFromTags(tags);

  if (customLabel) {
    const slug = customLabel.toLowerCase().replace(/\s+/g, '-');
    html += `<div class="product-badges__badge badge-${slug}-color">${customLabel}</div>`;
  }

  if (!hasHideSaleTag) {
    const discount = getDiscountPercent(minPrice, comparePrice);

    if (discount > 0) {
      html += `<div class="d-badges d-badges--discount-off"><div class="d-badge d-off">-${discount}%</div></div>`;
    }
  }

  const absorbency = product.absorbency?.value;

  if (absorbency) {
    try {
      const levels = JSON.parse(absorbency);

      if (levels?.length) {
        const levelMap = { Light: 1, Medium: 2, High: 3 };
        const localizedStrings = theme.strings ?? {};
        let maxLevel = 0;
        let label = '';

        if (levels.length > 1) {
          for (const level of levels) {
            const mappedLevel = levelMap[level] ?? 0;
            if (mappedLevel > maxLevel) maxLevel = mappedLevel;
          }
          label = localizedStrings.absorbencyMixed ?? 'Mixed';
        } else {
          const first = levels[0];
          maxLevel = levelMap[first] ?? 0;
          const labelMap = {
            Light: localizedStrings.absorbencyLight ?? 'Light',
            Medium: localizedStrings.absorbencyMedium ?? 'Medium',
            High: localizedStrings.absorbencyHeavy ?? 'Heavy',
          };
          label = labelMap[first] ?? first;
        }

        if (maxLevel > 0) {
          let icons = '';
          for (let i = 1; i <= 3; i++) {
            icons += i <= maxLevel ? dropFilledSvg : dropEmptySvg;
          }

          const flowLabel = localizedStrings.absorbencyFlow ?? 'Flow';
          html += `<span class="product-badges__badge product-badges__badge--absorbency"><span class="product-badges__badge-title"><span>${label} </span><span>${flowLabel}</span></span><span class="product-badges__badge-icons">${icons}</span></span>`;
        }
      }
    } catch { /* skip */ }
  }

  return html;
};

const buildCustomBadgesHtml = (product) => {
  const raw = product.customBadges?.value;
  if (!raw) return '';

  try {
    const badges = JSON.parse(raw);
    if (!badges?.length) return '';

    const showSaleBadge = theme.settings.showSaleBadge;
    const nonSale = badges.filter((b) => b !== 'Sale');
    const hasSaleOnly = badges.length === 1 && badges[0] === 'Sale';

    if (hasSaleOnly && showSaleBadge) {
      return `<div class="product-badges__container grid-product__badges grid-product__badges--bottom product-badges__container--sale">
        <div class="product-badges__badge badge-sale-color product-badges__badge--sale">Sale</div>
      </div>`;
    }

    if (!nonSale.length) return '';

    const items = nonSale.map((badge) => {
      const slug = badge.toLowerCase().replace(/\s+/g, '-');
      return `<div class="product-badges__badge badge-${slug}-color">${badge}</div>`;
    }).join('');

    return `<div class="product-badges__container grid-product__badges grid-product__badges--bottom product-badges__container--custom">${items}</div>`;
  } catch { return ''; }
};

let depictBadgeMap = null;

const getDepictBadgeMap = () => {
  if (depictBadgeMap) return depictBadgeMap;

  depictBadgeMap = {};
  const list = window.customBadgesDepict ?? [];

  for (const obj of list) {
    for (const [key, value] of Object.entries(obj)) {
      depictBadgeMap[key] = value;
    }
  }

  return depictBadgeMap;
};

const buildTagBadgesHtml = (product, numericId) => {
  const tags = product.tags ?? [];
  const parts = [];

  if (tags.includes('New_Arrivals')) {
    const label = theme.strings?.badgeNew ?? 'New';
    parts.push(`<div class="product-badges__tag-badge product-badges__tag-badge--new">${label}</div>`);
  }

  if (tags.includes('Bestsellers')) {
    const label = theme.strings?.badgeBestseller ?? 'Bestseller';
    parts.push(`<div class="product-badges__tag-badge product-badges__tag-badge--bestseller">${label}</div>`);
  }

  const depictRaw = product.customBadgesDepict?.value;

  if (depictRaw) {
    try {
      const depictHandles = JSON.parse(depictRaw);
      const badgeMap = getDepictBadgeMap();

      for (const handle of depictHandles) {
        const name = badgeMap[handle];
        if (!name) continue;

        const slug = handle.toLowerCase().replace(/\s+/g, '-');
        parts.push(`<div class="product-badges__tag-badge product-badges__tag-badge--depict badge-${slug}-color">${name}</div>`);
      }
    } catch { /* skip */ }
  }

  if (!parts.length) return '';

  return `<div class="product-badges__tag-badges grid-product__tag-badges hidden" data-product-id="${numericId}">${parts.join('')}</div>`;
};

const fetchCollectionProducts = async (handle) => {
  const token = theme.settings.storefrontApiToken;
  if (!token) return null;

  const country = normalizeContextCode(theme.settings?.storefrontCountry);
  const language = normalizeContextCode(theme.settings?.storefrontLanguage);
  const cacheKey = `${handle}:${country ?? 'default'}:${language ?? 'default'}`;

  if (collectionCache.has(cacheKey)) return collectionCache.get(cacheKey);

  const query = `query CollectionProducts($handle: String!, $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {
    collection(handle: $handle) {
      products(first: 50) {
        nodes {
          id
          handle
          title
          tags
          featuredImage {
            url
            altText
            width
            height
          }
          images(first: 2) {
            nodes {
              url
              altText
              width
              height
            }
          }
          priceRange {
            minVariantPrice { amount currencyCode }
            maxVariantPrice { amount currencyCode }
          }
          compareAtPriceRange {
            minVariantPrice { amount currencyCode }
            maxVariantPrice { amount currencyCode }
          }
          options {
            name
            optionValues {
              name
              swatch { color }
            }
          }
          themeLabel: metafield(namespace: "theme", key: "label") { value }
          absorbency: metafield(namespace: "custom", key: "absorbency") { value }
          customBadgesDepict: metafield(namespace: "custom", key: "custom_badges_depict") { value }
          customBadges: metafield(namespace: "custom", key: "custom_badges") { value }
        }
      }
    }
  }`;

  try {
    const url = `https://${window.Shopify.shop}/api/${storefrontApiVersion}/graphql.json`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        variables: {
          handle,
          country,
          language,
        },
      }),
    });

    const data = await response.json();
    const products = data?.data?.collection?.products?.nodes ?? [];

    collectionCache.set(cacheKey, products);
    return products;
  } catch (error) {
    console.error('[swatch] Failed to fetch collection products:', error);
    return null;
  }
};

const debounce = (func, wait) => {
  let timeout;

  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const observeOnce = (element, callback, rootMargin) => {
  if (!('IntersectionObserver' in window)) {
    callback();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        callback();
        observer.disconnect();
      }
    },
    { rootMargin },
  );

  observer.observe(element);
};

class CollectionProductSwatch extends HTMLElement {
  constructor() {
    super();
    this.gridItem = null;
    this.products = null;
    this.originalProductId = null;
    this.activeProductId = null;
    this.clickedProductId = null;
    this.loaded = false;
    this.imageTemplate = null;
    this.activeWrapper = null;
    this.activePrice = null;
    this.activeTagBadge = null;
    this.activeSwatch = null;

    this.debouncedHover = debounce((productId) => {
      this.toggleProducts(productId);
    }, 100);

    this.debouncedLeave = debounce(() => {
      const hoveredSwatch = this.querySelector('.d-swatch:hover');
      if (hoveredSwatch) return;

      this.classList.remove('visit');

      const targetId = this.clickedProductId ?? this.originalProductId;
      this.toggleProducts(targetId);
    }, 200);
  }

  connectedCallback() {
    this.gridItem = this.closest('.grid__item');
    if (!this.gridItem) return;

    this.originalProductId = this.dataset.currentProductId;
    this.activeProductId = this.originalProductId;
    this.detectImageStructure();

    const isExpanded = !theme?.settings?.depictCollapsedSwatches;

    if (isExpanded) {
      observeOnce(this.gridItem, () => this.loadSwatches(), '600px');
    } else {
      this.setupLazyLoad();
    }

    this.bindMobileColorInfo();
  }

  detectImageStructure() {
    const wrapper = this.gridItem.querySelector('.grid__item-image-wrapper');
    const ratioDiv = wrapper?.querySelector('.grid__image-ratio');
    const mainImg = wrapper?.querySelector('image-element img');
    const hoverImg = wrapper?.querySelector('.grid-product__secondary-image image-element img');

    this.activeWrapper = wrapper;
    this.activePrice = this.gridItem.querySelector('.grid-product__price');
    this.activeTagBadge = this.gridItem.querySelector('.grid-product__tag-badges');

    this.imageTemplate = {
      useRatio: !!ratioDiv,
      ratioClass: ratioDiv?.className ?? '',
      imgClass: mainImg?.className ?? '',
      imgSizes: mainImg?.getAttribute('sizes') ?? '100vw',
      hasHoverImage: !!wrapper?.querySelector('.grid-product__secondary-image'),
      hoverImgClass: hoverImg?.className ?? '',
    };
  }

  setupLazyLoad() {
    const colorInfo = this.querySelector('.d-color-info');

    if (colorInfo) {
      colorInfo.addEventListener(
        'pointerenter',
        () => this.loadSwatches(),
        { once: true },
      );
    }

    observeOnce(this.gridItem, () => this.loadSwatches(), '400px');
  }

  bindMobileColorInfo() {
    const colorInfo = this.querySelector('.d-color-info');
    if (!colorInfo) return;

    colorInfo.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (this.loaded) {
        this.toggleMobileSwatches();
        return;
      }

      this.loadSwatches().then(() => this.toggleMobileSwatches());
    });
  }

  async loadSwatches() {
    if (this.loaded) return;
    this.loaded = true;

    const handle = this.dataset.collectionHandle;

    if (!handle) {
      this.removeLoadingState();
      this.style.display = 'none';
      return;
    }

    this.products = await fetchCollectionProducts(handle);

    if (!this.products?.length || this.products.length < 2) {
      this.removeLoadingState();
      this.style.display = 'none';
      return;
    }

    this.updateColorInfo();
    this.renderSiblingCards();
    this.renderSwatchStrip();
    this.initSwiper();
    this.bindSwatchEvents();
    this.removeLoadingState();
  }

  removeLoadingState() {
    this.classList.remove('d-swatches-wrapper--loading');

    const skeleton = this.querySelector('.d-swatches-skeleton');
    if (skeleton) skeleton.remove();
  }

  updateColorInfo() {
    const moreEl = this.querySelector('.d-color-info__more');
    if (!moreEl) return;

    const count = this.products.length - 1;
    const colorsText = theme.strings?.moreColors ?? 'Colors';

    moreEl.textContent = `+${count} ${colorsText}`;
  }

  renderSiblingCards() {
    const originalWrapper = this.gridItem.querySelector('.grid__item-image-wrapper');
    const originalPrice = this.gridItem.querySelector('.grid-product__price');
    const originalTagBadges = this.gridItem.querySelector('.grid-product__tag-badges');
    const meta = this.gridItem.querySelector('.grid-product__meta');

    let imageInsertTarget = originalWrapper;
    let priceInsertTarget = originalPrice;
    let tagBadgeInsertTarget = originalTagBadges;

    for (const product of this.products) {
      const numericId = getNumericId(product.id);
      if (numericId === this.originalProductId) continue;

      const wrapperHtml = this.buildImageWrapper(product, numericId);
      imageInsertTarget.insertAdjacentHTML('afterend', wrapperHtml);
      imageInsertTarget = imageInsertTarget.nextElementSibling;

      if (originalPrice) {
        const priceHtml = this.buildPrice(product, numericId);
        priceInsertTarget.insertAdjacentHTML('afterend', priceHtml);
        priceInsertTarget = priceInsertTarget.nextElementSibling;
      }

      const tagHtml = buildTagBadgesHtml(product, numericId);

      if (tagHtml && meta) {
        if (tagBadgeInsertTarget) {
          tagBadgeInsertTarget.insertAdjacentHTML('afterend', tagHtml);
          tagBadgeInsertTarget = tagBadgeInsertTarget.nextElementSibling;
        } else {
          meta.insertAdjacentHTML('afterbegin', tagHtml);
          tagBadgeInsertTarget = meta.querySelector(`[data-product-id="${numericId}"].grid-product__tag-badges`);
        }
      }
    }
  }

  buildImageWrapper(product, numericId) {
    const mainImage = product.featuredImage ?? product.images?.nodes?.[0];
    const hoverImage = product.images?.nodes?.[1];
    const imageTemplate = this.imageTemplate;
    const mainSrc = mainImage?.url ? `${mainImage.url}&width=720` : '';
    const mainSrcset = mainImage?.url ? buildSrcset(mainImage.url, mainWidths) : '';
    const mainAlt = mainImage?.altText ?? product.title;
    const wrapperClass = imageTemplate.useRatio ? imageTemplate.ratioClass : 'image-wrap image-wrap--has-preview-image';

    let hoverHtml = '';

    if (imageTemplate.hasHoverImage && hoverImage?.url) {
      const hoverSrc = `${hoverImage.url}&width=720`;
      const hoverSrcset = buildSrcset(hoverImage.url, hoverWidths);

      hoverHtml = `
        <div class="grid-product__secondary-image small--hide">
          <image-element data-aos="image-fade-in">
            <img src="${hoverSrc}" srcset="${hoverSrcset}" class="${imageTemplate.hoverImgClass}" loading="lazy" alt="${mainAlt}" sizes="${imageTemplate.imgSizes}" fetchpriority="auto">
          </image-element>
        </div>`;
    }

    const topBadges = buildTopBadgesHtml(product);
    const customBadges = buildCustomBadgesHtml(product);

    return `<a href="/products/${product.handle}" class="grid__item-image-wrapper hidden" data-product-id="${numericId}">
      <div class="grid-product__image-mask">
        <div class="${wrapperClass}">
          <image-element data-aos="image-fade-in">
            <img src="${mainSrc}" srcset="${mainSrcset}" class="${imageTemplate.imgClass}" loading="lazy" alt="${mainAlt}" sizes="${imageTemplate.imgSizes}" fetchpriority="auto">
          </image-element>
        </div>
        ${hoverHtml}
      </div>
      ${topBadges}
      ${customBadges}
    </a>`;
  }

  buildPrice(product, numericId) {
    const minPrice = product.priceRange?.minVariantPrice?.amount;
    const maxPrice = product.priceRange?.maxVariantPrice?.amount;
    const compareMin = product.compareAtPriceRange?.minVariantPrice?.amount;
    const priceVaries = minPrice !== maxPrice;
    const onSale = compareMin && parseFloat(compareMin) > parseFloat(minPrice);
    const formattedMinPrice = formatPrice(minPrice);
    const productFromLabel = theme.strings?.productFrom ?? theme.strings?.fromText ?? '';

    let priceContent = formattedMinPrice;

    if (priceVaries) {
      priceContent = `${productFromLabel}${formattedMinPrice}`.trim();
    }

    if (onSale) {
      priceContent += `
        <span class="visually-hidden">Regular price</span>
        <span class="grid-product__price--original">${formatPrice(compareMin)}</span>
        <span class="visually-hidden">Sale price</span>`;

      if (theme.settings?.showSaveAmount) {
        const parsedMinPrice = parseFloat(minPrice);
        const parsedCompareAtPrice = parseFloat(compareMin);
        const saveType = theme.settings?.saveType;
        let savedAmount = '';

        if (saveType === 'dollar') {
          savedAmount = formatPrice(String(parsedCompareAtPrice - parsedMinPrice));
        } else {
          const rawDiscountPercent = ((parsedCompareAtPrice - parsedMinPrice) / parsedCompareAtPrice) * 100;
          savedAmount = `${Math.floor(rawDiscountPercent / 5 + 0.5) * 5}%`;
        }

        const savePriceTemplate = theme.strings?.savePrice;
        const savePriceLabel = savePriceTemplate?.includes('[saved_amount]')
          ? savePriceTemplate.replace('[saved_amount]', savedAmount)
          : `Save ${savedAmount}`;

        priceContent += ` <span class="grid-product__price--savings">${savePriceLabel}</span>`;
      }
    }

    return `<div class="grid-product__price hidden" data-product-id="${numericId}">${priceContent}</div>`;
  }

  renderSwatchStrip() {
    const slides = this.products.map((product) => {
      const { name: colorName, swatchColor } = getColorOption(product);
      const hex = getColorHex(colorName, swatchColor);
      const light = isLightColor(colorName, hex);
      const numericId = getNumericId(product.id);
      const isSelected = numericId === this.originalProductId;

      return `<div class="swiper-slide d-swatch-item">
        <a href="/products/${product.handle}"
          data-color-name="${colorName}"
          class="d-swatch${isSelected ? ' selected' : ''}${light ? ' light-colored' : ''}"
          aria-label="${product.title}"
          style="--background:${hex}"
          data-product-id="${numericId}"></a>
      </div>`;
    }).join('');

    const container = document.createElement('div');
    container.className = 'swiper-container';

    container.innerHTML = `
      <div class="product-swatch-slider-button-wrapper">
        <button aria-label="Scroll left" class="left d-navbutton swiper-button swiper-button-prev" type="button">
          ${arrowLeftSvg}
        </button>
        <button aria-label="Scroll right" class="right d-navbutton swiper-button swiper-button-next" type="button">
          ${arrowRightSvg}
        </button>
      </div>
      <div class="d-swatches d-swatches--slider swiper js-product-swatches-slider product-swatches-slider">
        <div class="swiper-wrapper sliding">${slides}</div>
      </div>`;

    this.appendChild(container);
    this.activeSwatch = container.querySelector('.d-swatch.selected');
  }

  initSwiper() {
    const slider = this.querySelector('.js-product-swatches-slider');
    if (!slider || typeof Swiper === 'undefined') return;

    new Swiper(slider, {
      slidesPerView: 5,
      slidesPerGroup: 3,
      spaceBetween: 3,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        1200: {
          spaceBetween: 5,
          slidesPerView: 6,
        },
      },
    });
  }

  bindSwatchEvents() {
    const swatches = this.querySelectorAll('.d-swatch');
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    for (const swatch of swatches) {
      swatch.addEventListener('click', (e) => this.handleSwatchClick(e));

      if (!isTouchDevice) {
        swatch.addEventListener('pointerenter', (e) => this.handleSwatchHover(e));
        swatch.addEventListener('pointerleave', (e) => this.handleSwatchLeave(e));
      }
    }
  }

  handleSwatchClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const swatch = e.currentTarget;
    const productId = swatch.dataset.productId;
    if (!productId) return;

    this.clickedProductId = productId;

    if (this.activeSwatch) {
      this.activeSwatch.classList.remove('selected');
    }

    swatch.classList.add('selected');
    this.activeSwatch = swatch;
    this.toggleProducts(productId);

    const colorName = swatch.dataset.colorName;

    if (colorName) {
      const nameEl = this.querySelector('.d-color-info__name');
      if (nameEl) nameEl.textContent = colorName;
    }
  }

  handleSwatchHover(e) {
    const swatch = e.currentTarget;
    const productId = swatch.dataset.productId;
    if (!productId) return;

    this.classList.add('visit');
    this.debouncedHover(productId);
  }

  handleSwatchLeave(e) {
    const relatedTarget = e.relatedTarget;
    if (relatedTarget?.closest?.('.d-swatch')) return;

    this.debouncedLeave();
  }

  toggleProducts(productId) {
    if (!this.gridItem || this.activeProductId === productId) return;

    this.activeProductId = productId;

    const selector = `[data-product-id="${productId}"]`;

    if (this.activeWrapper) {
      this.activeWrapper.classList.add('hidden');
    }

    const nextWrapper = this.gridItem.querySelector(`.grid__item-image-wrapper${selector}`);

    if (nextWrapper) {
      nextWrapper.classList.remove('hidden');
      this.activeWrapper = nextWrapper;
    }

    if (this.activePrice) {
      this.activePrice.classList.add('hidden');
    }

    const nextPrice = this.gridItem.querySelector(`.grid-product__price${selector}`);

    if (nextPrice) {
      nextPrice.classList.remove('hidden');
      this.activePrice = nextPrice;
    }

    if (this.activeTagBadge) {
      this.activeTagBadge.classList.add('hidden');
    }

    const nextTagBadge = this.gridItem.querySelector(`.grid-product__tag-badges${selector}`);

    if (nextTagBadge) {
      nextTagBadge.classList.remove('hidden');
      this.activeTagBadge = nextTagBadge;
    } else {
      this.activeTagBadge = null;
    }
  }

  toggleMobileSwatches() {
    if (!this.gridItem) return;

    this.closeOtherMobileContainers();
    this.gridItem.classList.toggle('mobile-show-swatches');
  }

  closeOtherMobileContainers() {
    const gridParent = this.gridItem.closest('.collection-grid') ?? document;

    for (const item of gridParent.querySelectorAll('.grid__item.mobile-show-swatches')) {
      if (item !== this.gridItem) {
        item.classList.remove('mobile-show-swatches');
      }
    }
  }
}

customElements.define('collection-product-swatch', CollectionProductSwatch);
